// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FormInputWrapper } from "@insite/mobius/FormField";
import { PaginationStyle } from "@insite/mobius/Pagination";
import { filtersLayoutStyles } from "@sc/App/Widgets/MyLists/MyListsFilterLayout";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

filtersLayoutStyles.container = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        column-gap: 22px;
        row-gap: 16px;
        justify-content: space-between;
        ${xScreen("lte", "xs")} {
            flex-direction: column;
        }
    `,
};

filtersLayoutStyles.leftSideContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        column-gap: 22px;
        row-gap: 11px;
        ${xScreen("lte", "xs")} {
            flex-direction: column;
            justify-content: flex-start;
            > div {
                width: 100%;
            }
        }
    `,
};

filtersLayoutStyles.pagination = {
    css: css`
        display: flex;
        align-items: flex-end;
        margin-left: auto;
        ${PaginationStyle} {
            margin: 0;
            flex-wrap: nowrap;
            ${FormInputWrapper} {
                width: 51px;
            }
            nav {
                width: auto;
                ul {
                    display: flex;
                    flex-wrap: nowrap;
                }
            }
            span[class^="PerPageSelect"] {
                width: auto;
            }
        }
    `,
};
